module.exports = __webpack_public_path__ + "media/application/images/projects/images/morocco-f37bf227d1e28d7e45f7e6f8c71eb806.jpg";